// extracted by mini-css-extract-plugin
module.exports = {"root":"TotalCount_root__Nb-6a"};